'use client'

import {useShellText} from '@/components/shell/ShellText'
import {ThemeSwitch} from './ThemeSwitch'

export function ThemeToggle() {
  const t = useShellText('shell')
  return <ThemeSwitch toLight={t('themeToLight')} toDark={t('themeToDark')} />
}
